import { dayjs } from '@mobi/utils/date'
import { keys } from '@core/Services/Analytics/keys'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { fullClientVersion } from '@core/Utils/clientVersion'

type EventKey = (typeof keys)[keyof typeof keys]

export const trackKey = (key: EventKey): void => {
  userAccountState$?.take(1).subscribe(state => {
    const accountNumber = state?.accountNumber
    window.dataLayer?.push({
      event: key,
      accountNumber,
      appVersion: fullClientVersion,
      timeStamp: makeTimestamp(),
      eventTimeStamp: Date.now(),
    })
  })
}

export const trackEvent = (event: EventKey, data: Record<string | number, unknown>): void => {
  userAccountState$?.take(1).subscribe(state => {
    const accountNumber = state?.accountNumber
    window.dataLayer?.push({
      event,
      ...data,
      accountNumber: data?.accountNumber ?? accountNumber,
      appVersion: fullClientVersion,
      timeStamp: makeTimestamp(),
      eventTimeStamp: Date.now(),
    })
  })
}

// =============
// Local Helpers
// =============

function makeTimestamp() {
  return dayjs().format('YYYY-MM-DD HH:mm:ss')
}
